module.exports = __webpack_public_path__ + "static/media/SH 18.7d693d02.mp3";